function getPdfInfos(post) {
    pdfInfos = post;
}
var pdfInfos;
jQuery('document').ready(function ($) {
    if ($('body').hasClass('single')) {
        var baseURL_1;
        if (window.location.hostname === 'localhost') {
            baseURL_1 = 'http://localhost/megamark-site';
        }
        else {
            baseURL_1 = document.location.origin + '/megamark-site';
        }
        var fontLoaded = 0;
        var filesLoaded = 0;
        var files = {};
        // var fontColorDark: '#3D3D3C';
        var fonts = {
            'Heavy': baseURL_1 + '/wp-content/themes/rsw-megamark/assets/fonts/Maax-Bold.otf',
            'Bold': baseURL_1 + '/wp-content/themes/rsw-megamark/assets/fonts/Maax-Bold.otf',
            'Book': baseURL_1 + '/wp-content/themes/rsw-megamark/assets/fonts/Maax-Regular.otf'
            // 'Heavy': baseURL + '/wp-content/themes/rsw-megamark/assets/fonts/NexaHeavy.otf',
            // 'Bold': baseURL + '/wp-content/themes/rsw-megamark/assets/fonts/NexaBold.otf',
            // 'Book': baseURL + '/wp-content/themes/rsw-megamark/assets/fonts/NexaBook.otf'
        };
        // Function used to retrieve the 64base image string used to include the picture in the PDF
        var toDataURL = function (url) { return fetch(url)
            .then(function (response) { return response.blob(); })
            .then(function (blob) { return new Promise(function (resolve, reject) {
            var reader = new FileReader();
            reader.onloadend = function () { return resolve({ data: reader.result, url: url }); };
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        }); }); };
        // Checking if the single page contains 6 or 4 pictures, to check what will be the PDF layout
        if (pdfInfos.imgs.length == 6) {
            files = {
                logomm: {
                    url: pdfInfos['logomm'],
                    data: ''
                },
                logoprojet: {
                    url: pdfInfos['logoprojet']['sizes']['pdf-large'],
                    data: ''
                },
                img1: {
                    url: pdfInfos['imgs'][0]['sizes']['pdf-large'],
                    data: ''
                },
                img2: {
                    url: pdfInfos['imgs'][1]['sizes']['pdf-small'],
                    data: ''
                },
                img3: {
                    url: pdfInfos['imgs'][2]['sizes']['pdf-small'],
                    data: ''
                },
                img4: {
                    url: pdfInfos['imgs'][3]['sizes']['pdf-small'],
                    data: ''
                },
                img5: {
                    url: pdfInfos['imgs'][4]['sizes']['pdf-small'],
                    data: ''
                },
                img6: {
                    url: pdfInfos['imgs'][5]['sizes']['pdf-medium'],
                    data: ''
                }
            };
        }
        else if (pdfInfos.imgs.length == 4) {
            files = {
                logomm: {
                    url: pdfInfos['logomm'],
                    data: ''
                },
                logoprojet: {
                    url: pdfInfos['logoprojet']['sizes']['pdf-large'],
                    data: ''
                },
                img1: {
                    url: pdfInfos['imgs'][0]['sizes']['pdf-large'],
                    data: ''
                },
                img2: {
                    url: pdfInfos['imgs'][1]['sizes']['pdf-small'],
                    data: ''
                },
                img3: {
                    url: pdfInfos['imgs'][2]['sizes']['pdf-small'],
                    data: ''
                },
                img4: {
                    url: pdfInfos['imgs'][3]['sizes']['pdf-full'],
                    data: ''
                }
            };
        }
        // We start downloading images and font files in order to create the PDF
        for (var file in files) {
            // For each picture that will appead in the PDF, we load it manually and get the 64base string necessary
            toDataURL(files[file].url)
                .then(function (response) {
                for (var file in files) {
                    if (files[file].url === response.url) {
                        files[file].data = response.data;
                    }
                }
                filesLoaded += 1;
                // When all pictures have been loaded, we proceed with loading the fonts
                // TODO: We could make this better, mixing images and fonts loading to do eveything in parallel
                if (filesLoaded == Object.keys(files).length) {
                    // TODO: Try to group this in a foreach (first didn't work but might have come from something else)
                    var xhr = new XMLHttpRequest();
                    xhr.open('GET', baseURL_1 + '/wp-content/themes/rsw-megamark/assets/fonts/Maax-Regular.otf', true);
                    xhr.responseType = 'arraybuffer';
                    xhr.onload = function (e) {
                        if (this.status == 200) {
                            doc.registerFont('book', xhr.response);
                            fontLoaded++;
                            if (fontLoaded == Object.keys(fonts).length) {
                                // When all fonts have been loaded, start creating the PDF
                                // Check in all 3 calls, as we don't know which one will finish first
                                showPDF();
                            }
                        }
                    };
                    xhr.send();
                    var xhr2 = new XMLHttpRequest();
                    xhr2.open('GET', baseURL_1 + '/wp-content/themes/rsw-megamark/assets/fonts/Maax-Bold.otf', true);
                    xhr2.responseType = 'arraybuffer';
                    xhr2.onload = function (e) {
                        if (this.status == 200) {
                            doc.registerFont('bold', xhr2.response);
                            fontLoaded++;
                            if (fontLoaded == Object.keys(fonts).length) {
                                // When all fonts have been loaded, start creating the PDF
                                // Check in all 3 calls, as we don't know which one will finish first
                                showPDF();
                            }
                        }
                    };
                    xhr2.send();
                    var xhr3 = new XMLHttpRequest();
                    xhr3.open('GET', baseURL_1 + '/wp-content/themes/rsw-megamark/assets/fonts/Maax-Bold.otf', true);
                    xhr3.responseType = 'arraybuffer';
                    xhr3.onload = function (e) {
                        if (this.status == 200) {
                            doc.registerFont('heavy', xhr3.response);
                            fontLoaded++;
                            if (fontLoaded == Object.keys(fonts).length) {
                                // When all fonts have been loaded, start creating the PDF
                                // Check in all 3 calls, as we don't know which one will finish first
                                showPDF();
                            }
                        }
                    };
                    xhr3.send();
                }
            });
        }
        // PDF variables
        var pageW = 841, pageH = 595, paddingTop = 30, paddingRight = 20, paddingBottom = 30, paddingLeft = 20;
        // Initializing the PDF
        var doc = new PDFDocument({
            layout: 'landscape',
            size: [pageH, pageW],
            margins: {
                top: 30,
                bottom: 30,
                left: 20,
                right: 20
            }
        });
        var stream = doc.pipe(blobStream());
        function showPDF() {
            /***********************************************
             * FIRST PAGE
             **************/
            // First column
            // ---––––-----
            var pad = 20;
            var logoH = 35;
            var logoProjectH = 40;
            var titleH = 100;
            var missionH = 90;
            var fontColor = '#404040';
            var fontColorLight = '#505050';
            doc.image(files.logomm.data, paddingLeft, paddingTop, { fit: [120, logoH] });
            doc.image(files.logoprojet.data, paddingLeft, paddingTop + logoH + pad, { fit: [200, logoProjectH] });
            doc.fontSize(20);
            doc.fillColor(fontColor)
                // .text(doc.currentLineHeight())
                .font('book')
                .text(pdfInfos.title.slice(0, 200), paddingLeft, paddingTop + logoH + pad + logoProjectH + pad, {
                width: 200,
                height: titleH
            });
            doc.font('bold')
                .fontSize(16)
                .text(pdfInfos.mission.string, paddingLeft, paddingTop + logoH + pad + logoProjectH + pad + titleH + 10, {
                width: 183,
                height: 30
            });
            doc.font('book')
                .fontSize(10)
                .text(pdfInfos.mission.value, paddingLeft, paddingTop + logoH + pad + logoProjectH + pad + titleH + 10 + 25, {
                width: 183,
                height: missionH,
                lineGap: 2
            });
            pdfInfos.chiffres.forEach(function (element, key) {
                if (element.value > 0) {
                    doc.font('book')
                        .fontSize(10)
                        .text(element.title + (element.subtitle !== null && element.subtitle !== '' ? ' / ' + element.subtitle : ''), paddingLeft, paddingTop + logoH + pad + logoProjectH + pad + titleH + pad + 30 + missionH + key * 45, {
                        width: 183,
                        height: 20
                    })
                        .moveDown(0.5)
                        .font('bold')
                        .fontSize(16)
                        .text(element.value, {
                        width: 183,
                        height: 20
                    });
                    doc.moveTo(paddingLeft, paddingTop + logoH + pad + logoProjectH + pad + titleH + pad + 30 + missionH + key * 45 + 13)
                        .lineTo(180, paddingTop + logoH + pad + logoProjectH + pad + titleH + pad + 30 + missionH + key * 45 + 13)
                        .lineWidth(0.3)
                        .fillAndStroke(fontColorLight)
                        .stroke();
                }
            });
            // Second column
            // ---––––-----
            var projectH = 42;
            var projectW = 200;
            var rightColW = 600;
            doc.font('heavy')
                .fontSize(10)
                .text(pdfInfos.projet, pageW - paddingRight - rightColW + 10, paddingTop + 5, {
                width: projectW,
                height: projectH
            });
            doc.moveTo(pageW - paddingRight - rightColW, paddingTop)
                .lineTo(pageW - paddingRight - rightColW, paddingTop + 35)
                .lineWidth(0.2)
                .fillAndStroke(fontColorLight)
                .stroke();
            doc.font('book')
                .fontSize(10)
                .text(pdfInfos.division + ' /', pageW - paddingRight - rightColW + 150 + 10, paddingTop + 5, {
                width: projectW,
                height: projectH
            })
                .text(pdfInfos.offre, pageW - paddingRight - rightColW + 150 + 10, paddingTop + 5 + 15, {
                width: 2 * projectW,
                height: 2 * projectH
            });
            doc.moveTo(pageW - paddingRight - rightColW + 150, paddingTop)
                .lineTo(pageW - paddingRight - rightColW + 150, paddingTop + 35)
                .lineWidth(0.2)
                .fillAndStroke(fontColorLight)
                .stroke();
            doc.font('book')
                .fontSize(10)
                .text('1/2', pageW - 100, paddingTop + 5, {
                width: 50
            });
            doc.image(files.img1.data, pageW - paddingRight - rightColW, 75, { fit: [rightColW, 290] });
            doc.image(files.img2.data, pageW - paddingRight - 295 - 295 - 10, 375, { fit: [295, 190] });
            doc.image(files.img3.data, pageW - paddingRight - 295, 375, { fit: [295, 190] });
            /***********************************************
             * SECOND PAGE
             **************/
            doc.addPage({
                layout: 'landscape',
                size: [pageH, pageW],
                margins: {
                    top: 30,
                    bottom: 30,
                    left: 20,
                    right: 20
                }
            });
            // First column
            // ---––––-----
            doc.image(files.logomm.data, paddingLeft, paddingTop, { fit: [120, logoH] });
            doc.fillColor(fontColor);
            doc.font('bold')
                .fontSize(16)
                .text(pdfInfos.challenge.string, paddingLeft, paddingTop + logoH + pad, {
                width: 183,
                height: 30
            });
            var challengeH = 150;
            if (pdfInfos.challenge.value !== null && pdfInfos.challenge.value !== '') {
                doc.font('book')
                    .fontSize(10)
                    .text(pdfInfos.challenge.value, paddingLeft, paddingTop + logoH + pad + 30, {
                    width: 183,
                    height: challengeH,
                    lineGap: 1
                })
                    .moveDown(1);
            }
            else {
                doc.moveDown(1);
            }
            var developmentH = 80;
            pdfInfos.development.forEach(function (element, key) {
                doc.font('bold')
                    .fontSize(8)
                    .text(element.string, {
                    width: 183,
                    height: 10,
                    lineGap: 1
                });
                doc.font('book')
                    .fontSize(8)
                    .text(element.value, {
                    width: 183,
                    height: developmentH,
                    lineGap: 1
                })
                    .moveDown(1);
            });
            doc.font('heavy')
                .fontSize(6)
                .text('8, impasse du progrès 93100 Montreuil', paddingLeft, pageH - paddingBottom - 20, {
                width: 183,
                height: 10,
                lineGap: 2
            });
            doc.font('heavy')
                .fontSize(6)
                .text('Tél.', paddingLeft, pageH - paddingBottom - 12, {
                width: 183,
                height: 10,
                lineGap: 2
            });
            doc.font('book')
                .fontSize(6)
                .text('01 41 58 69 69', paddingLeft + 12, pageH - paddingBottom - 12, {
                width: 183,
                height: 10,
                lineGap: 2
            });
            doc.font('heavy')
                .fontSize(6)
                .text('Fax.', paddingLeft, pageH - paddingBottom - 5, {
                width: 183,
                height: 10,
                lineGap: 2
            });
            doc.font('book')
                .fontSize(6)
                .text('01 42 87 48 58', paddingLeft + 15, pageH - paddingBottom - 5, {
                width: 183,
                height: 10,
                lineGap: 2
            });
            // Second column
            // ---––––-----
            doc.font('heavy')
                .fontSize(10)
                .text(pdfInfos.projet, pageW - paddingRight - rightColW + 10, paddingTop + 5, {
                width: projectW,
                height: projectH
            });
            doc.moveTo(pageW - paddingRight - rightColW, paddingTop)
                .lineTo(pageW - paddingRight - rightColW, paddingTop + 35)
                .lineWidth(0.2)
                .fillAndStroke(fontColorLight)
                .stroke();
            doc.font('book')
                .fontSize(10)
                .text(pdfInfos.division + ' /', pageW - paddingRight - rightColW + 150 + 10, paddingTop + 5, {
                width: projectW,
                height: projectH
            })
                .text(pdfInfos.offre, pageW - paddingRight - rightColW + 150 + 10, paddingTop + 5 + 15, {
                width: 2 * projectW,
                height: 2 * projectH
            });
            doc.moveTo(pageW - paddingRight - rightColW + 150, paddingTop)
                .lineTo(pageW - paddingRight - rightColW + 150, paddingTop + 35)
                .lineWidth(0.2)
                .fillAndStroke(fontColorLight)
                .stroke();
            doc.font('book')
                .fontSize(10)
                .text('2/2', pageW - 100, paddingTop + 5, {
                width: 50
            });
            if (pdfInfos.imgs.length == 6) {
                doc.image(files.img4.data, pageW - paddingRight - 295 - 295 - 10, 75, { fit: [295, 190] });
                doc.image(files.img5.data, pageW - paddingRight - 295, 75, { fit: [295, 190] });
                doc.image(files.img6.data, pageW - paddingRight - 600, 275, { fit: [460, 290] });
            }
            else if (pdfInfos.imgs.length == 4) {
                doc.image(files.img4.data, pageW - paddingRight - 600, 75, { fit: [600, 490] });
            }
            doc.end();
        }
        // Launch the PDF download
        var saveData = (function () {
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            return function (blob, fileName) {
                var url = window.URL.createObjectURL(blob);
                a.href = url;
                a.download = fileName;
                a.click();
                window.URL.revokeObjectURL(url);
            };
        }());
        var pdfFile;
        // When the PDF is done being created, we can save it in a variable, ready to be downloaded
        stream.on('finish', function () {
            pdfFile = stream.toBlob('application/pdf');
            // saveData(blob, 'aa.pdf');
        });
        $('.single__action_print').on('click', function () {
            saveData(pdfFile, 'Megamark-' + pdfInfos.projet.split(' ').join('_') + '.pdf');
        });
    }
});
